import CopyToClipboard from './CopyToClipboard'
import './copy-to-clipboard.css'

export default CopyToClipboard
